var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.show,"width":"400px","close-on-click-modal":false,"destroy-on-close":""},on:{"update:visible":function($event){_vm.show=$event},"close":_vm.close}},[_c('div',{staticClass:"qrcode"},[_c('qrcode',{attrs:{"value":_vm.qrcode}}),_c('div',{staticClass:"tip"},[_vm._v("微信扫一扫，授权登录")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }